import * as brandColors from '../../../utils/brandColors';

export default () => ({
  container: {
    display: 'flex',
    width: '100%',
  },
  card: {
    marginTop: 0,
    flex: 1,
  },
  badgeContainer: { flex: 1 },
  statusIcon: {
    color: 'white',
    margin: '1em 0',
  },
  date: {
    color: brandColors.grey[800],
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: 2,
  },
  cardHeader: {
    padding: '12px 0 0',
    width: '100%',
  },
  cardHeaderContent: { flex: 0 },
  cardFooter: {
    color: brandColors.grey[600],
    borderRadius: '0 0 6px 6px',
  },
  comment: {
    color: brandColors.grey[900],
    padding: '0 41px',
  },
  commentLastChild: { '&:last-child': { paddingBottom: 0 } },
  body: {
    margin: '.5em 0',
    wordBreak: 'break-word',
    background: brandColors.grey[50],
    borderRadius: '0px 12px 12px 12px',
    display: 'inline-block',
    padding: '.5em 1em',
  },
  editContainer: {
    minWidth: 250,
    padding: 1,
    borderRadius: 1,
    backgroundColor: brandColors.grey[100],
  },
  buttonContainer: {
    textAlign: 'right',
    marginTop: '1rem',
  },
  cancelButton: { color: brandColors.grey[600] },
  statusContainer: { padding: '1em 0' },
  cardAvatar: { flex: 1 },
  eventIdField: { color: brandColors.grey[500] },
});
